<!-- rate your experience (mockup openReviewForm / reviewFormHtml) -->
<app-modal [open]="openSig()" (close)="onClose()"
           [title]="editing() ? 'Edit your review' : 'Rate your experience'"
           [subtitle]="modelSig().vendorName + ' · ' + modelSig().eventDateLong">
  <div class="cv-rev-ov">
    <div class="b7 fz13 cv-rev-ov-t">Overall experience</div>
    <div class="muted fz11 cv-rev-ov-s">How was working with {{ modelSig().vendorName }}?</div>
    <div class="cv-rev-pick">
      @for (n of stars; track n) {
        <button type="button" class="cv-rev-set" [class.on]="n <= starsOf(modelSig().overall)"
                [attr.aria-label]="n + (n === 1 ? ' star' : ' stars')"
                (click)="setStars(modelSig().overall, n)">★</button>
      }
    </div>
    <textarea class="cv-rev-ta" rows="3" maxlength="2000"
              placeholder="Share a few words about your experience…"
              [value]="noteOf(modelSig().overall)"
              (input)="setNote(modelSig().overall, $any($event.target).value)"></textarea>
  </div>

  @if (modelSig().services.length) {
    <div class="cl cv-rev-sec">Rate each service</div>
    @for (s of modelSig().services; track s.offeringId) {
      <div class="cv-rev-svc">
        <div class="b7 fz13">{{ s.name }}</div>
        <div class="muted fz11 cv-rev-own">{{ s.ownerName }}</div>
        <div class="cv-rev-pick">
          @for (n of stars; track n) {
            <button type="button" class="cv-rev-set" [class.on]="n <= starsOf(s)"
                    [attr.aria-label]="s.name + ': ' + n + (n === 1 ? ' star' : ' stars')"
                    (click)="setStars(s, n)">★</button>
          }
        </div>
        <input type="text" class="cv-rev-in" maxlength="2000"
               placeholder="Optional note for this service…"
               [value]="noteOf(s)"
               (input)="setNote(s, $any($event.target).value)">
      </div>
    }
  }

  <div modal-footer>
    <button class="btn block cv-rev-submit" type="button"
            [disabled]="!valid() || saving()" (click)="submit()">
      {{ editing() ? 'Update review' : 'Submit review' }}
    </button>
    <div class="muted fz11 cv-rev-foot">
      {{ valid()
        ? (editing()
            ? 'Your changes update your public review.'
            : 'Your review goes live on the vendor’s page once submitted.')
        : 'Tap the stars to give an overall rating before submitting.' }}
    </div>
  </div>
</app-modal>
